module.exports = __webpack_public_path__ + "static/media/policeSiren.913acbc1.png";